import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-sub-title-1',
  props: {
    innerText: { default: '大标题' },
    index: {}
  },
  setup(__props: any) {

const props = __props;

const translateY = ref(props.innerText.length * 26 + 65);
const x2 = ref(963 - props.innerText.length * 26);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="40" viewBox="0 0 1023.539 30">
  <g id="xiaobiao1" transform="translate(-1 -9)">
    <path id="路径_4611" data-name="路径 4611" d="M0,0H20.165V20.166H0Z" transform="translate(25.063 10.48) rotate(45)" fill="var(--theme-color-1)" fill-opacity="0.6"/>
    <text id="项目执行人性别分布" transform="translate(46.039 32)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${props.innerText}</tspan></text>
    <path id="路径_854" data-name="路径 854" d="M0,0H20.165V20.166H0Z" transform="translate(15.26 10.48) rotate(45)" fill="var(--theme-color-1)"/>
    <line id="直线_696" data-name="直线 696" x2="${x2.value}" transform="translate(${translateY.value} 25)" fill="none" stroke="var(--theme-color-1)" stroke-width="1"/>
  </g>
</svg>
`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "svg-block",
    innerHTML: svg
  }))
}
}

})